/**
 * ChallengeCardSkeleton Component
 * Skeleton loader matching ChallengeCard structure
 */

import React from 'react';
import { View } from 'react-native';
import { SkeletonTitle, SkeletonText, SkeletonBadge } from '../ui/Skeleton/SkeletonVariants';
import { useSkeletonCardStyles } from '../../src/shared/hooks/useSkeletonStyles';
import { challengeCardSkeletonStyles } from './ChallengeCardSkeleton.styles';

export const ChallengeCardSkeleton: React.FC = () => {
  const { card: cardStyle } = useSkeletonCardStyles({
    borderRadius: 20,
    padding: 12,
    paddingHorizontal: 14,
    shadow: 'small',
    marginVertical: 4,
  });

  return (
    <View style={cardStyle}>
      {/* Header Section - matches collapsed state (default) */}
      <View style={challengeCardSkeletonStyles.header}>
        <View style={challengeCardSkeletonStyles.headerLeft}>
          <SkeletonTitle width="60%" />
          <View style={challengeCardSkeletonStyles.hintContainer}>
            <SkeletonText width="40%" />
          </View>
        </View>
        <View style={challengeCardSkeletonStyles.headerRight}>
          <SkeletonBadge width={60} />
          <SkeletonBadge width={70} />
        </View>
      </View>
    </View>
  );
};

